module.exports = __webpack_public_path__ + "static/media/vase5.93156b07.png";